module.exports = "pegasus/assets/graycircle-twitter.gif";